// @flow
// Settings configured here will be merged into the final config object.
import React from 'react'

/** Recursive type for storing translated strings in objects */
type MessageList = { [key: string]: string | MessageList }
type LocalisedMessagesList = { [localeCode: 'de' | 'fr']: MessageList }

/**
 * Create a translation Service function, using the provided MessageList and
 * the currenty locale string.
 * @param messageList - The object containing the translated strings. The first
 *   level keys are the locale strings, then you're free to use whathever IDs
 *   you need to identify your strings.
 * @param locale - The locale string (i.e. 'en', 'de', 'fr' …)
 * @returns {function(string): (string)}
 */
const translationServiceFactory = (
  messageList: LocalisedMessagesList,
  locale: string
) => {
  return (key: string) =>
    key
      .split('.')
      .reduce((messages, prop) => messages[prop], messageList[locale]) ||
    'TRANSLATED STRING NOT FOUND'
}

export default {
  routes: {
    municipalitySelection: '/select-municipality',
    voteSelection: '/select-vote',
    article: '/article/for/'
  },
  defaultVotes: {
    sbi: null,
    ueberwachung: null,
    hornkuh: null
  },
  searchFallback: (
    <div className='municipality-search' style={{ opacity: 0.3 }}>
      <div className='ui top attached massive borderless stackable menu' />
      <div
        className='ui bottom attached loading segment results'
        style={{ minHeight: '5rem' }}
      />
    </div>
  ),
  translationServiceFactory
}
